export const SET_PRODUCT = "SET_PRODUCT"; // Create and edit product
export const GET_PRODUCTS = "GET_PRODUCTS";
export const SET_PROMOTION = "SET_PROMOTION"; // Create and edit promotion
export const REMOVE_PROMOTION = "REMOVE_PROMOTION"; // Create and edit promotion
export const GET_PROMOTIONS = "GET_PROMOTIONS";
export const UPDATE_PRODUCT = "UPDATE_PRODUCT";
export const UPDATE_PROMOTION = "UPDATE_PROMOTION";
export const GET_BUYER_BASIC_INFO = "GET_BUYER_BASIC_INFO";
export const REMOVE_PRODUCT = "REMOVE_PRODUCT";
